export class ProgramInfo {
  name: string = ''
  faculty: string = ''
  degree: string = ''
  years: string = ''
  passingScore: number = 0
  price: string = ''
}

export class StudyingProgramCardModel {
  id: string = ''
  name: string = ''
  image: string = ''
  programInfo: ProgramInfo = {
    name: '',
    faculty: '',
    degree: '',
    years: '',
    passingScore: 0,
    price: ''
  }
}
